import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { userLoggedIn } from "../features/auth/authSlice";

export default function useAuthCheck() {
  const [authCheck, setAuthCheck] = useState(false);
  const dispatch = useDispatch();

  useEffect(() => {
    const response = localStorage.getItem("auth");

    if (response) {
      const data = JSON.parse(response);

      if (data?.accessToken && data?.user) {
        dispatch(
          userLoggedIn({
            accessToken: data.accessToken,
            user: data.user,
          })
        );
      }
    }

    setAuthCheck(true);
    return () => {
      setAuthCheck(false);
    };
  }, [dispatch, setAuthCheck]);

  return authCheck;
}
